var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_c('v-overlay',{attrs:{"absolute":_vm.absolute,"opacity":_vm.opacity,"z-index":_vm.zIndex}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"#FF3700","indeterminate":""}}):_vm._e(),_c('h1',{staticClass:"message-color"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }